import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect";

import FilterRequest = App.Http.Requests.FilterRequest;

import { useScenarioSelectOptions } from "./useScenarioSelectOptions";

interface ScenarioSelectSearchableProps extends SearchableSelectWrapperProps {
    filter?: FilterRequest;
    formStructureId?: string;
}

export const ScenarioSelectSearchable = ({ filter, formStructureId, ...props }: ScenarioSelectSearchableProps) => {
    const hookResult = useScenarioSelectOptions({ filter, formStructureId });

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.scenarios"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
